import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ErrorService, ErrorMessage } from '../../services/error.service';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
  selector: 'app-error-notifications',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="error-notifications-container">
      <div *ngFor="let error of errors" 
           class="notification" 
           [ngClass]="error.type"
           [@fadeInOut]>
        <div class="notification-content">
          <span class="message">{{ error.message || 'An error occurred' }}</span>
          <button class="close-btn" (click)="dismissError(error.id)">×</button>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .error-notifications-container {
      position: fixed;
      top: 20px;
      right: 20px;
      z-index: 1000;
      max-width: 350px;
      max-height: 80vh;
      overflow-y: auto;
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .notification {
      padding: 12px 14px;
      border-radius: var(--ap-radius-sm, 6px);
      border: 1px solid transparent;
      border-left-width: 3px;
      display: flex;
      align-items: center;
      font-size: 13px;
    }

    .notification-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
    }

    .error {
      background: var(--ap-danger-soft, #FEE2E2);
      border-color: rgba(180,35,24,.2);
      border-left-color: var(--ap-danger, #B42318);
      color: var(--ap-danger, #B42318);
    }

    .warning {
      background: var(--ap-warn-soft, #FEF3C7);
      border-color: rgba(180,83,9,.2);
      border-left-color: var(--ap-warn, #B45309);
      color: var(--ap-warn, #B45309);
    }

    .info {
      background: var(--ap-primary-soft, #E8EEFC);
      border-color: rgba(47,91,218,.2);
      border-left-color: var(--ap-primary, #2F5BDA);
      color: var(--ap-primary, #2F5BDA);
    }

    .message {
      flex-grow: 1;
      margin-right: 10px;
    }

    .close-btn {
      background: none;
      border: none;
      font-size: 18px;
      cursor: pointer;
      color: inherit;
      opacity: 0.7;
      transition: opacity 0.15s;
    }

    .close-btn:hover {
      opacity: 1;
    }
  `],
  animations: [
    trigger('fadeInOut', [
      transition(':enter', [
        style({ opacity: 0, transform: 'translateX(100%)' }),
        animate('300ms ease-out', style({ opacity: 1, transform: 'translateX(0)' }))
      ]),
      transition(':leave', [
        animate('200ms ease-in', style({ opacity: 0, transform: 'translateX(100%)' }))
      ])
    ])
  ]
})
export class ErrorNotificationsComponent implements OnInit, OnDestroy {
  errors: ErrorMessage[] = [];
  private subscription: Subscription = new Subscription();
  
  constructor(private errorService: ErrorService) { }
  
  ngOnInit(): void {
    this.subscription.add(
      this.errorService.errors$.subscribe(errors => {
        this.errors = errors;
      })
    );
  }
  
  dismissError(id: string): void {
    this.errorService.clearError(id);
  }
  
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
